import { formatUtcTimestamp } from './datetime';

export function ageInQueueLabel(createdAt: string, now: Date = new Date()): string {
  const seconds = Math.floor((now.getTime() - new Date(createdAt).getTime()) / 1000);
  if (seconds < 60) return `${seconds}s`;
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m`;
  const hours = Math.floor(minutes / 60);
  return hours < 24 ? `${hours}h` : `${Math.floor(hours / 24)}d`;
}

export type AgeUrgency = 'red' | 'yellow' | 'gray';

export function ageInQueueTone(createdAt: string, now: Date = new Date()): AgeUrgency {
  const hours = Math.floor((now.getTime() - new Date(createdAt).getTime()) / (60 * 60 * 1000));
  if (hours >= 48) return 'red';
  if (hours >= 24) return 'yellow';
  return 'gray';
}

export const AGE_TONE_CLASSES: Record<AgeUrgency, string> = {
  red: 'bg-red-50 text-red-700',
  yellow: 'bg-amber-50 text-amber-700',
  gray: 'bg-gray-100 text-gray-500',
};

export function ageInQueueTooltip(createdAt: string): string {
  return `Created ${formatUtcTimestamp(createdAt)}`;
}
